import { Subscription } from "rxjs";

export interface UploadedFile {
    fileSrc: string | 'assets/icons/files/pdf.svg' | 'assets/icons/files/excel.svg' | 'assets/icons/files/unknown-file.svg';
    fileName: string;
    fileSizeMB: string;
    currentUploadProgress: number;
    paused: boolean;
    uploadSubscription: Subscription | null;
    canceled: boolean;
}

export interface FileResponse {
    id: string;
    filename: string | null;
    file_url: string | null;
    user_id: string | null;
    company_id: string | null;
    energy_type: FileUploadEnergyType | null;
    file_type: FileUploadFileType | null;
    status: string | null;
    external_status: string | null;
    external_status_updated_at: string | null;
}

export interface FileDownload {
    download_url: string;
}

export interface ViewFile {
    download_url: string;
}

export interface FullFileDataResponse {
    file: any | null;
    electricity_invoice: any | null;
    gas_invoice: any | null;
    location: any | null;
    file_logs: any | null;
    [key: string]: any;
}

export enum FileUploadEnergyType {
    ELECTRICITY = 'ELECTRICITY',
    GAS = 'GAS'
}

export enum FileUploadFileType {
    INVOICE = 'INVOICE',
    CONTRACT = 'CONTRACT'
}

export enum FileStatus {
    CREATED = "CREATED",
    UPLOADED = "UPLOADED",
    IN_EXTRACTION = "IN_EXTRACTION",
    EXTRACTED = "EXTRACTED",
    DELETED = "DELETED",
    IN_PROCESSING = "IN_PROCESSING",
    PROCESSED = "PROCESSED",
    DATA_INCOMPLETE = "DATA_INCOMPLETE",
    DISPUTED = "DISPUTED",
    DUPLICATE_PERIOD = "DUPLICATE_PERIOD",
    ERROR = "ERROR"
}

export enum ExternalFileStatus {
    UPLOADED = "UPLOADED",
    RETRYING = "RETRYING",
    ADDED = "ADDED",
    WAITING_FOR_PROCESSING = "WAITING_FOR_PROCESSING",
    IN_PROCESS = "IN_PROCESS",
    DONE = "DONE",
    ERROR = "ERROR",
    VALIDATION_ERROR = "VALIDATION_ERROR",
    
    // AI statuses
    IN_QUEUE = "IN_QUEUE",
    IN_EXTRACTION = "IN_EXTRACTION",
    EXTRACTION_FAILED = "EXTRACTION_FAILED",
    EXTRACTED = "EXTRACTED"
}

export interface FilesInExtractionResponse {
  in_progress: boolean;
  files_in_progress: number;
}